const proposalDialogConstantsAR = {
  proposalRequestDialogTitle: 'تفاصيل الطلب',
  proposalRequestStatus: 'حالة الطلب',
  videoDetailsTitle: 'تفاصيل المقطع',
  videoDetailsThumbnailLabel: 'صورة مصغرة',
  videoDetailsVideoTitleLabel: 'عنوان المقطع',
  videoDetailsDurationLabel: 'المدة',
  videoDetailsDescriptionLabel: 'الوصف',
  videoDetailsPublishedDateLabel: 'تاريخ النشر',
  userDetailsTitle: 'تفاصيل المستخدم',
  userDetailsNameLabel: 'الاسم',
  userDetailsEmailLabel: 'البريد الإلكتروني',
  userDetailsCompanyLabel: 'الشركة',
  licenseRequestDetailsTitle: 'تفاصيل طلب الترخيص',
  licenseRequestResolutionLabel: 'الدقة',
  licenseRequestCountryLabel: 'البلد',
  licenseRequestPeriodLabel: 'فترة الترخيص',
  licenseRequestDeliveryMethodLabel: 'طريقة التسليم',
  licenseRequestDeliveryDateLabel: 'تاريخ التسليم',
  licenseRequestChannelsLabel: 'منصات العرض',
  rightsLabel: 'الحقوق',
  exclusiveLabel: 'حصري',
  nonExclusiveLabel: 'غير حصري',
  holdbackLabel: 'الحجز',
  noHoldback: 'لا يوجد',
  holdbackOneMonth: 'شهر',
  holdbackThreeMonths: '3 أشهر',
  holdbackSixMonths: '6 أشهر',
  holdbackNineMonths: '9 أشهر',
  notesTitle: 'ملاحظات',
  quoteNewStatus: 'جديد',
  quotePendingStatus: 'قيد الانتظار',
  quoteAcceptedStatus: 'موافق',
  quotePaidStatus: 'مدفوع',
  quoteCanceledStatus: 'مرفوض',
  quoteCanceledStatusByUser: 'ملغى',
  quoteSaveButton: 'حفظ الطلب',
  rejectionReasonPlaceholder: 'سبب الرفض',
  addPricePlaceholder: 'إضافة السعر',
  addPriceButton: 'إضافة السعر',
  updatePriceButton: 'تحديث السعر',
  rejectButton: 'رفض',
  priceFieldValidation: 'الرجاء إدخال السعر',
  rejectionReasonFieldValidation: 'الرجاء إدخال سبب الرفض',
  conflictsMessage: 'هناك تعارض مع طلبات: ',
  worldwide: 'عالمي',
  updateLicensePeriod: 'تعديل فترة الترخيص',
  periodNotAvailable: 'هذه الفترة غير متاحة، يرجى تجربة فترة أخرى.',
  licensePeriodUpdateSuccessfully: 'تم تعديل فترة الترخيص بنجاح',
  proposalRequestRejectSuccessfully: 'تم رفض عرض السعر',
  videoDetailsOwnerLabel: 'المالك',
};

export default proposalDialogConstantsAR;
